module.exports = __webpack_public_path__ + "static/media/shape3.defe32a5.svg";